<template>
    <div class="title-head">
        <div class="leftTitle" :style="{paddingLeft:isPaddingLeft == true?'10px':''}">{{title}}</div>
        <div class="rightTitle"  v-if="isShowRightText" @click="goList">更多</div>
    </div>
</template>
<script>

export default {
    props: {
    title: {
      type: String,
      required: true
    },
    isShowRightText:{
      type: Boolean,
      default: true
    },
    isPaddingLeft:{
      type: Boolean,
      default: false
    },
    more:{
      type: String,
      default: ''
    }
  },
  data() {
    return {

    };
  },
  mounted() {


  },
  methods: {
    goList(){
      switch(Number(this.more)){
        case 1:
        this.$router.push({ path: "/playlist"});
        break;
        case 2:
        this.$router.push({ path: "/singer" });
        break;
        case 3:
        this.$router.push({ path: "/djradio" });
        break;
      }
    }
  },
};
</script>
<style lang="less" scoped>
  .rightTitle{
font-weight: 500;
font-size: 14px;
color: #7A7A7A;
text-align: right;
font-style: normal;
text-transform: none;
}
.title-head{
    display: flex;
    justify-content: space-between;
    align-items: center;
  border-bottom: 2px solid #DDDDDD;
}
.leftTitle{
    border-bottom: 2px solid #313131;
    padding-bottom: 12px;

}
//移动端
@media (max-width: 768px) {

.leftTitle{
font-weight: 800;
font-size: 22px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
}

}
//PC端
@media (min-width: 769px) {

.leftTitle{
font-weight: 800;
font-size: 24px;
color: #313131;
text-align: left;
font-style: normal;
text-transform: none;
}

}

</style>